// extracted by mini-css-extract-plugin
export var grid = "_21-0";
export var span1 = "_21-2";
export var span10 = "_21-b";
export var span10L = "_21-z";
export var span10M = "_21-n";
export var span10Xl = "_21-1b";
export var span11 = "_21-c";
export var span11L = "_21-10";
export var span11M = "_21-o";
export var span11Xl = "_21-1c";
export var span12 = "_21-d";
export var span12L = "_21-11";
export var span12M = "_21-p";
export var span12Xl = "_21-1d";
export var span1L = "_21-q";
export var span1M = "_21-e";
export var span1Xl = "_21-12";
export var span2 = "_21-3";
export var span2L = "_21-r";
export var span2M = "_21-f";
export var span2Xl = "_21-13";
export var span3 = "_21-4";
export var span3L = "_21-s";
export var span3M = "_21-g";
export var span3Xl = "_21-14";
export var span4 = "_21-5";
export var span4L = "_21-t";
export var span4M = "_21-h";
export var span4Xl = "_21-15";
export var span5 = "_21-6";
export var span5L = "_21-u";
export var span5M = "_21-i";
export var span5Xl = "_21-16";
export var span6 = "_21-7";
export var span6L = "_21-v";
export var span6M = "_21-j";
export var span6Xl = "_21-17";
export var span7 = "_21-8";
export var span7L = "_21-w";
export var span7M = "_21-k";
export var span7Xl = "_21-18";
export var span8 = "_21-9";
export var span8L = "_21-x";
export var span8M = "_21-l";
export var span8Xl = "_21-19";
export var span9 = "_21-a";
export var span9L = "_21-y";
export var span9M = "_21-m";
export var span9Xl = "_21-1a";
export var stretch = "_21-1";